(function () {
  if (window.__sfInit) return; window.__sfInit = true;
  const money = (c) => '€' + (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  $$('[data-sf-countdown]').forEach((el) => {
    const mode = el.dataset.mode || 'fixed';
    if (mode === 'off') return;
    const box = $('[data-sf-countdown-time]', el);
    let end;
    const startSession = () => {
      end = Date.now() + (+el.dataset.seconds || 3959) * 1000;
      try { sessionStorage.setItem('sfCdEnd', String(end)); } catch (e) {}
    };
    if (mode === 'session') {
      let saved = null;
      try { saved = +sessionStorage.getItem('sfCdEnd'); } catch (e) {}
      if (saved && saved > Date.now()) end = saved; else startSession();
    } else {
      const raw = (el.dataset.end || '').trim();
      end = new Date(raw.replace(' ', 'T')).getTime();
      if (!raw || isNaN(end)) return;
    }
    const tick = () => {
      let d = end - Date.now();
      if (d <= 0) { if (mode === 'session') { startSession(); d = end - Date.now(); } else { box.hidden = true; return; } }
      box.hidden = false;
      const h = Math.floor(d / 36e5), m = Math.floor((d % 36e5) / 6e4), s = Math.floor((d % 6e4) / 1e3);
      $('[data-h]', box).textContent = String(h).padStart(2, '0');
      $('[data-m]', box).textContent = String(m).padStart(2, '0');
      $('[data-s]', box).textContent = String(s).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  });

  $$('[data-sf-gallery]').forEach((g) => {
    const slides = $('[data-sf-slides]', g), thumbs = $$('[data-sf-thumb]', g);
    const real = $$('.sf-gallery__slide', slides), n = real.length;
    const strip = thumbs.length ? thumbs[0].parentElement : null;
    let shown = -1;
    const setActive = (i) => {
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      // Vorschau-Leiste läuft mit: aktives Bild in die Mitte der Leiste schieben
      if (!strip || i === shown || !thumbs[i]) return;
      shown = i;
      const t = thumbs[i], sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
      const left = strip.scrollLeft + (tr.left - sr.left) - (strip.clientWidth - tr.width) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };
    if (n < 2) return;
    // Endlos-Swipe: Kopie des letzten Bildes vorne, Kopie des ersten hinten
    const headClone = real[n - 1].cloneNode(true), tailClone = real[0].cloneNode(true);
    [headClone, tailClone].forEach((c) => { c.setAttribute('aria-hidden', 'true'); $$('img', c).forEach((i) => i.removeAttribute('loading')); });
    slides.insertBefore(headClone, real[0]);
    slides.appendChild(tailClone);
    const w = () => slides.clientWidth || 1;
    let cur = 0, timer;
    const jump = (pos) => {
      slides.style.scrollSnapType = 'none';
      slides.scrollLeft = w() * pos;
      void slides.offsetWidth;
      slides.style.scrollSnapType = '';
    };
    const settle = () => {
      const pos = Math.round(slides.scrollLeft / w());
      if (pos <= 0) jump(n); else if (pos >= n + 1) jump(1);
    };
    jump(1);
    requestAnimationFrame(() => jump(cur + 1));
    slides.addEventListener('scroll', () => {
      const pos = Math.round(slides.scrollLeft / w());
      cur = ((pos - 1) % n + n) % n;
      setActive(cur);
      clearTimeout(timer); timer = setTimeout(settle, 140);
    }, { passive: true });
    if ('onscrollend' in window) slides.addEventListener('scrollend', settle);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      slides.scrollTo({ left: w() * (+t.dataset.sfThumb + 1), behavior: 'smooth' });
    }));
    window.addEventListener('resize', () => jump(cur + 1));
  });

  $$('[data-sf-ing]').forEach((m) => {
    let last = null;
    const open = (e) => {
      last = e && e.currentTarget; m.hidden = false; document.body.classList.add('sf-lock');
      const c = $('.sf-ing__close', m); if (c) c.focus();
    };
    const close = () => {
      m.hidden = true; document.body.classList.remove('sf-lock');
      if (last) last.focus();
    };
    $$('[data-sf-ing-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-sf-ing-close]', m).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !m.hidden) close(); });
    const cta = $('[data-sf-ing-cta]', m);
    if (cta) cta.addEventListener('click', () => {
      close();
      const t = $('[data-sf-bundle]') || $('.sf-offer__purchase');
      if (!t) return;
      const head = $('.sf-header-section');
      const y = t.getBoundingClientRect().top + window.scrollY - (head ? head.offsetHeight : 0) - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  $$('[data-sf-rv]').forEach((r) => {
    const tr = $('[data-sf-rv-track]', r), n = tr.children.length;
    const step = () => (n > 1 ? tr.children[1].offsetLeft - tr.children[0].offsetLeft : tr.clientWidth) || 1;
    const idx = () => Math.round(tr.scrollLeft / step());
    const go = (i) => tr.scrollTo({ left: step() * ((i + n) % n), behavior: 'smooth' });
    const p = $('[data-sf-rv-prev]', r), nx = $('[data-sf-rv-next]', r);
    if (p) p.addEventListener('click', () => go(idx() - 1));
    if (nx) nx.addEventListener('click', () => go(idx() + 1));
  });

  const selectVariant = (id) => {
    $$('[data-sf-bundle]').forEach((b) => {
      let price = null, compare = 0;
      $$('.sf-bar', b).forEach((bar) => {
        const on = bar.dataset.variant === String(id);
        bar.classList.toggle('is-active', on);
        $('input', bar).checked = on;
        if (on) { price = +bar.dataset.price; compare = +bar.dataset.compare || 0; }
      });
      const inp = $('input[name="id"]', b);
      if (inp) inp.value = id;
      const p = $('[data-sf-atc-price]', b);
      if (p && price !== null) p.textContent = money(price);
      const cp = $('[data-sf-atc-compare]', b);
      if (cp && price !== null) { cp.hidden = !(compare > price); cp.textContent = compare > price ? money(compare) : ''; }
      const sumPrice = $('[data-sf-summary-current]', b), sumCompare = $('[data-sf-summary-compare]', b), sumSaving = $('[data-sf-summary-saving]', b);
      if(sumPrice && price !== null) sumPrice.textContent = money(price);
      if(sumCompare) {sumCompare.textContent=money(compare);sumCompare.hidden=!(compare>price);}
      if(sumSaving && price !== null) sumSaving.textContent=money(Math.max(0,compare-price));
      const comparison = $('[data-sf-atc-comparison]', b);
      if (comparison) comparison.hidden = !(compare > price);
      const activeBar = $('.sf-bar.is-active', b), packageName = $('[data-sf-selected-package]', b);
      if (packageName && activeBar) packageName.textContent = $('.sf-bar__title', activeBar).textContent;
      $$('[data-sf-sticky-price]').forEach((p) => { if (price !== null) p.textContent = money(price); });
    });
  };
  $$('[data-sf-bundle] .sf-bar').forEach((bar) => {
    bar.addEventListener('click', (e) => { e.preventDefault(); selectVariant(bar.dataset.variant); });
  });

  const cart = $('[data-sf-cart]');
  const api = (url, body) => fetch(root + url, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; });

  const renderCart = (c) => {
    $$('[data-cart-count]').forEach((n) => { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
    if (!cart) return;
    $('[data-sf-cart-count]', cart).textContent = c.item_count;
    const items = $('[data-sf-cart-items]', cart);
    items.innerHTML = c.items.map((it) => {
      const productId = String(it.product_id);
      const lineImage = productId === String(cart.dataset.productId) && cart.dataset.lineImage
        ? cart.dataset.lineImage
        : (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '');
      return `
      <div class="sf-line" data-key="${it.key}">
        <img src="${lineImage}" alt="">
        <div class="sf-line__info">
          <div class="sf-line__title">${it.product_title}</div>
          ${it.variant_title ? `<div class="sf-line__variant">${it.variant_title}</div>` : ''}
          <div class="sf-line__qty"><button type="button" data-q="-1" aria-label="weniger">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="mehr">+</button></div>
          <div><button type="button" class="sf-line__remove" data-remove>Entfernen</button></div>
        </div>
        <div class="sf-line__price">${money(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}</div>
      </div>`;
    }).join('');
    $('[data-sf-cart-empty]', cart).hidden = c.item_count > 0;
    $('[data-sf-cart-total]', cart).textContent = money(c.total_price);

    const sav = $('[data-sf-cart-savings]', cart);
    if (c.total_discount > 0) { sav.hidden = false; sav.textContent = `Du sparst ${money(c.total_discount)}`; } else sav.hidden = true;

    const th = +cart.dataset.threshold || 0;
    const txt = $('[data-sf-ship-text]', cart), bar = $('[data-sf-ship-bar]', cart);
    if (th > 0) {
      const left = th - c.total_price;
      txt.textContent = left > 0 ? cart.dataset.txtRemaining.replace('{amount}', money(left)) : cart.dataset.txtReached;
      bar.style.width = Math.min(100, (c.total_price / th) * 100) + '%';
    }

    const up = $('[data-sf-upsell]', cart);
    if (up) {
      const first = cart.dataset.firstVariant, upv = cart.dataset.upsellVariant;
      const hasFirst = c.items.some((i) => String(i.variant_id) === first);
      const hasUp = c.items.some((i) => String(i.variant_id) === upv);
      up.hidden = !(hasFirst && !hasUp);
    }
  };

  const openCart = () => { if (!cart) return; cart.hidden = false; document.body.classList.add('sf-lock'); };
  const closeCart = () => { if (!cart) return; cart.hidden = true; document.body.classList.remove('sf-lock'); };
  const showError = (m) => { const e = cart && $('[data-sf-cart-error]', cart); if (e) { e.hidden = !m; e.textContent = m || ''; } };
  const refresh = () => api('cart.js').then(renderCart);

  if (cart) {
    $$('[data-sf-cart-close]', cart).forEach((b) => b.addEventListener('click', closeCart));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
    cart.addEventListener('click', (e) => {
      const line = e.target.closest('.sf-line');
      if (line) {
        const qspan = $('.sf-line__qty span', line);
        let q = +qspan.textContent;
        if (e.target.matches('[data-q]')) q += +e.target.dataset.q;
        else if (e.target.matches('[data-remove]')) q = 0;
        else return;
        api('cart/change.js', { id: line.dataset.key, quantity: Math.max(0, q) }).then(renderCart).catch((er) => showError(er.message));
      }
      if (e.target.matches('[data-sf-upgrade]')) {
        const first = cart.dataset.firstVariant, upv = +cart.dataset.upsellVariant;
        api('cart.js').then((c) => {
          const it = c.items.find((i) => String(i.variant_id) === first);
          const chain = it ? api('cart/change.js', { id: it.key, quantity: 0 }) : Promise.resolve();
          return chain.then(() => api('cart/add.js', { items: [{ id: upv, quantity: 1 }] }));
        }).then(refresh).catch((er) => showError(er.message));
      }
    });
    $$('#sf-cart-icon, a[href$="/cart"]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refresh().then(openCart); }));
  }

  $$('[data-sf-form]').forEach((f) => f.addEventListener('submit', (e) => {
    if (!cart) return;
    e.preventDefault();
    const btn = $('[data-sf-atc]', f); btn.disabled = true; showError('');
    api('cart/add.js', { items: [{ id: +$('input[name="id"]', f).value, quantity: 1 }] })
      .then(refresh).then(openCart).catch((er) => { showError(er.message); openCart(); })
      .finally(() => (btn.disabled = false));
  }));

  $$('[data-sf-toggle] .sf-card__head').forEach((h) => h.addEventListener('click', () => {
    const c = h.closest('[data-sf-toggle]'); const o = c.classList.toggle('is-open'); h.setAttribute('aria-expanded', o);
  }));

  $$('[data-sf-tabs]').forEach((t) => {
    const btns = $$('[data-sf-tab]', t), cards = $$('.sf-review', t);
    const show = (k) => { btns.forEach((b) => b.classList.toggle('is-active', b.dataset.sfTab === k)); cards.forEach((c) => (c.hidden = c.dataset.topic !== k)); };
    btns.forEach((b) => b.addEventListener('click', () => show(b.dataset.sfTab)));
    if (btns[0]) show(btns[0].dataset.sfTab);
  });
})();
